<template>
  <div class="golfclub-page">
    <div v-if="viewType === VIEW_LIST" class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
            <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
              <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
              </select>
            </div>

           <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
          </div>

          <div class="box-body no-padding table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="width: 45px; text-align:center;">#</th>
                  <th style="text-align:left;">Action</th>
                  <th style="text-align:left;">Club Code</th>
                  <th style="text-align:left;">Club Name</th>
                  <th style="text-align:left;">Status</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(row, i) in listData" :key="row.id">
                  <td style="width:45px; text-align:center;">{{ startSequence + i + 1 }}</td>

                  <td style="width:85px; text-align:left;">
                    <a href="#" v-on:click.prevent="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                      <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                    </a>
                    <a href="#" v-on:click.prevent="onEdit(row)" ref="editRow" style="padding-right:5px">
                      <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                    </a>
                    <a href="#" v-on:click.prevent="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                      <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                    </a>
                  </td>

                  <td>{{ row.clubCode }}</td>
                  <td>{{ row.clubName }}</td>
                  <td>{{ row.status }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="box-footer">
            <div class="form-group">
              <label style="width:25px;text-align:right;">
                <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
              </label>
              <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
              </label>
              <label>
                Page
              </label>
              <label>
                <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
              </label>
              <label id="TotalPageText">
                {{ totalPages }}
              </label>
              <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
              </label>
              <label style="width:25px;text-align:left;">
                <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="viewType === VIEW_FORM" class="row center-block form-wrapper">
      <div class="col-md-12">
        <div class="box caddy-box">
          <div class="box-header caddy-box-header">
            <h4 class="box-title">
              {{ formMode === MODE_CREATE ? 'Create Golf Club' : (viewMode === MODE_VIEW ? 'Display Golf Club' : 'Edit Golf Club') }}
            </h4>
          </div>

          <div class="box-body">
            <div class="tab-bar">
              <button
                v-for="tab in tabs"
                :key="tab.key"
                type="button"
                class="tab-btn"
                :class="{ active: activeTab === tab.key }"
                @click="activeTab = tab.key"
              >
                {{ tab.label }}
              </button>
            </div>

            <div class="form-panel">
              <div class="field-row">
                <label class="field-label">Club Code*</label>
                <div class="field-control">
                  <input
                    v-model="form.clubCode"
                    type="text"
                    :disabled="viewMode === MODE_VIEW"
                  />
                </div>

                <label class="field-label right-label">Club Name*</label>
                <div class="field-control">
                  <input
                    v-model="form.clubName"
                    type="text"
                    :disabled="viewMode === MODE_VIEW"
                  />
                </div>
              </div>

              <div class="field-row">
                <label class="field-label">Number of Course</label>
                <div class="field-control small-select">
                  <select
                    v-model="form.course"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                  </select>
                </div>

                <label class="field-label right-label">Valid For All Users</label>
                <div class="field-control radio-row">
                  <label class="radio-inline">
                    <input
                      type="radio"
                      value="Yes"
                      v-model="form.validForAllUsers"
                      :disabled="viewMode === MODE_VIEW"
                    />
                    <span>Yes</span>
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      value="No"
                      v-model="form.validForAllUsers"
                      :disabled="viewMode === MODE_VIEW"
                    />
                    <span>No</span>
                  </label>
                </div>
              </div>

              <div class="field-row">
                <label class="field-label">Golf Outlet*</label>
                <div class="field-control">
                  <select
                    v-model="form.golfOutlet"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="GOLF">GOLF</option>
                    <option value="BANDUNG">BANDUNG</option>
                  </select>
                </div>

                <label class="field-label right-label">Membership Club*</label>
                <div class="field-control">
                  <select
                    v-model="form.membershipClub"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="PERFECT GOLF COURSE">PERFECT GOLF COURSE</option>
                    <option value="OTHER">OTHER</option>
                  </select>
                </div>
              </div>

              <div class="field-row">
                <label class="field-label">Currency*</label>
                <div class="field-control">
                  <select
                    v-model="form.currency"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="IDR">Indonesia Rupiah (IDR)</option>
                    <option value="USD">USD</option>
                  </select>
                </div>

                <label class="field-label right-label">Caddy Service*</label>
                <div class="field-control">
                  <select
                    v-model="form.caddyService"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="CADDY FEE">CADDY FEE</option>
                    <option value="OTHER">OTHER</option>
                  </select>
                </div>
              </div>

              <div class="field-row">
                <label class="field-label">Cart Service*</label>
                <div class="field-control">
                  <select
                    v-model="form.cartService"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="CART FEE">CART FEE</option>
                    <option value="OTHER">OTHER</option>
                  </select>
                </div>

                <label class="field-label right-label">Bag Drop Process</label>
                <div class="field-control radio-row">
                  <label class="radio-inline">
                    <input
                      type="radio"
                      value="Yes"
                      v-model="form.bagDropProcess"
                      :disabled="viewMode === MODE_VIEW"
                    />
                    <span>Yes</span>
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      value="No"
                      v-model="form.bagDropProcess"
                      :disabled="viewMode === MODE_VIEW"
                    />
                    <span>No</span>
                  </label>
                </div>
              </div>

              <div class="field-row">
                <label class="field-label">Passport System Mode*</label>
                <div class="field-control">
                  <select
                    v-model="form.passportSystemMode"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="Passport Card">Passport Card</option>
                    <option value="OTHER">OTHER</option>
                  </select>
                </div>

                <label class="field-label right-label"></label>
                <div class="field-control radio-row">
                   <label class="check-inline">
                  <input type="checkbox" v-model="form.PassportasaBagTag" :disabled="viewMode === MODE_VIEW" />
                  <span>Passport as a Bag Tag</span>
                </label>
                <label class="check-inline">
                  <input type="checkbox" v-model="form.MemberCardasaPassport" :disabled="viewMode === MODE_VIEW" />
                  <span>MemberCard as Passport</span>
                </label>
                </div>
              </div>

              <div class="field-row">
                <label class="field-label">Caddy Assigment Method*</label>
                <div class="field-control">
                  <select
                    v-model="form.caddyAssignmentMethod"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="Player">By Player</option>
                    <option value="OTHER">OTHER</option>
                  </select>
                </div>
              </div>

                <div class="field-row">
                <label class="field-label">Tournament Player Mode*</label>
                <div class="field-control">
                  <select
                    v-model="form.tournamentPlayerMode"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="OTHER">OTHER</option>
                  </select>
                </div>

                 <label class="field-label">Member Check in*</label>
                <div class="field-control">
                  <select
                    v-model="form.memberCheckin"
                    :disabled="viewMode === MODE_VIEW"
                  >
                    <option value="Bio Data">Using BIO Data</option>
                    <option value="OTHER">OTHER</option>
                  </select>
                </div>
              </div>

              <div class="field-row">
                <label class="field-label">Updated By</label>
                <div class="field-control">
                   <input
                    v-model="form.updatedBy"
                    type="text"
                    :disabled="viewMode === MODE_VIEW"
                  />
                          </div>

                 <label class="field-label">Created By</label>
                <div class="field-control">
                   <input
                    v-model="form.createdBy"
                    type="text"
                    :disabled="viewMode === MODE_VIEW"
                  />
                  <!-- <input :disabled="viewMode == MODE_VIEW" class="form-control " v-model="form.createdBy"> -->
                </div>
              </div>

              <div class="additional-box">
                <div class="side-title">Additional</div>

                <label class="check-inline">
                  <input type="checkbox" v-model="form.availableCaddyServices" :disabled="viewMode === MODE_VIEW" />
                  <span>Available Caddy Services</span>
                </label>
                <label class="check-inline">
                  <input type="checkbox" v-model="form.availableGolfServices" :disabled="viewMode === MODE_VIEW" />
                  <span>Available Golf Cart Services</span>
                </label>
                <label class="check-inline">
                  <input type="checkbox" v-model="form.availableOtherServices" :disabled="viewMode === MODE_VIEW" />
                  <span>Available Others Services</span>
                </label>
              </div>
            </div>
          </div>

          <div class="box-footer">
            <button class="btn btn-default" @click="cancelForm">Back</button>

            <button
              v-if="viewMode === MODE_VIEW"
              class="btn btn-primary"
              @click="onEdit(form)"
            >
              Edit
            </button>

            <button
              v-if="viewMode === MODE_UPDATE"
              class="btn btn-primary"
              @click="saveForm"
            >
              Save
            </button>

            <button
              v-if="viewMode === MODE_UPDATE"
              class="btn btn-default"
              @click="cancelEdit"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'GolfClubView',
  data () {
    return {
      VIEW_LIST,
      VIEW_FORM,
      MODE_NONE,
      MODE_CREATE,
      MODE_UPDATE,
      MODE_VIEW,
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formMode: MODE_CREATE,
      activeTab: 'general',
      tabs: [
        { key: 'general', label: 'General Info' },
        { key: 'additional', label: 'Additional Info' },
        { key: 'default', label: 'Default Data' },
        { key: 'user', label: 'User Restriction' }
      ],
      inquiryParam: {
        pageSize: 10,
        CurrentPageNumber: 1
      },
      startSequence: 0,
      totalPages: 1,
      form: {
        id: null,
        clubCode: '',
        clubName: '',
        course: '2',
        validForAllUsers: 'Yes',
        golfOutlet: 'GOLF',
        membershipClub: 'PERFECT GOLF COURSE',
        currency: 'IDR',
        caddyService: 'CADDY FEE',
        cartService: 'CART FEE',
        bagDropProcess: 'Yes',
        passportSystemMode: 'Passport Card',
        caddyAssignmentMethod: 'By Player',
        enableFlightSwapWarning: false,
        tournamentPlayerMode: '',
        memberCheckin: '',
        PassportasaBagTag: true,
        MemberCardasaPassport: true,
        availableCaddyServices: true,
        availableGolfServices: true,
        availableOtherServices: false,
        updatedBy: 'Admin',
        updatedAt: '18-Dec-2020 13:23',
        createdBy: 'Admin',
        createdAt: '28-Sep-2020 9:17'
      },
      listData: [
        { id: 1, clubCode: 'PIGC', clubName: 'Perfect Golf Club', course: 2, golfOutlet: 'Jakarta', membershipClub: 'Yes', currency: 'IDR', status: 'Active' },
        { id: 2, clubCode: 'BSD', clubName: 'BSD Golf Club', course: 3, golfOutlet: 'Tangerang', membershipClub: 'Yes', currency: 'IDR', status: 'Active' }
      ]
    }
  },

  methods: {
    inquiry() {
      return true
    },

    changePageSize() {
      return true
    },

    gotoPage(event) {
      return true
    },

    changePage(page) {
      return true
    },

    initForm() {
      this.form = {
        id: null,
        clubCode: '',
        clubName: '',
        course: '2',
        validForAllUsers: 'Yes',
        golfOutlet: 'GOLF',
        membershipClub: 'PERFECT GOLF COURSE',
        currency: 'IDR',
        caddyService: 'CADDY FEE',
        cartService: 'CART FEE',
        bagDropProcess: 'Yes',
        passportSystemMode: 'Passport Card',
        caddyAssignmentMethod: 'By Player',
        enableFlightSwapWarning: false,
        tournamentPlayerMode: '',
        memberCheckin: '',
        PassportasaBagTag: true,
        MemberCardasaPassport: true,
        availableCaddyServices: true,
        availableGolfServices: true,
        availableOtherServices: false,
        updatedBy: 'Admin',
        updatedAt: '18-Dec-2020 13:23',
        createdBy: 'Admin',
        createdAt: '28-Sep-2020 9:17'
      }
    },

    onCreate() {
      this.initForm()
      this.formMode = MODE_CREATE
      this.viewMode = MODE_CREATE
      this.viewType = VIEW_FORM
    },

    onEdit(data) {
      this.form = { ...data }
      this.formMode = MODE_UPDATE
      this.viewMode = MODE_UPDATE
      this.viewType = VIEW_FORM
    },

    onDisplay(data) {
      this.form = { ...data }
      this.formMode = MODE_UPDATE
      this.viewMode = MODE_VIEW
      this.viewType = VIEW_FORM
    },

    onDelete(data) {
      const index = this.listData.findIndex(item => item.id === data.id)
      if (index >= 0) {
        this.listData.splice(index, 1)
      }
    },

    cancelForm() {
      this.viewType = VIEW_LIST
      this.viewMode = MODE_NONE
    },

    cancelEdit() {
      this.viewMode = MODE_VIEW
    },

    saveForm() {
      if (this.viewMode === MODE_CREATE) {
        this.listData.push({
          ...this.form,
          id: Date.now(),
          status: 'Active'
        })
      } else if (this.viewMode === MODE_UPDATE) {
        const index = this.listData.findIndex(item => item.id === this.form.id)
        if (index >= 0) {
          this.listData.splice(index, 1, { ...this.form })
        }
      }

      this.viewType = VIEW_LIST
      this.viewMode = MODE_NONE
    }
  }
}
</script>

<style scoped>
.golfclub-page {
  background: #f1f5fb;
  min-height: 100%;
  padding: 12px;
  color: #2d405a;
  font-family: Arial, Helvetica, sans-serif;
}


.form-wrapper {
  margin-top: 10px;
}

.tab-bar {
  display: flex;
  align-items: center;
  gap: 0;
  border: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.12);
  padding: 8px 8px 0;
  min-height: 42px;
}

.tab-btn {
  border: 1px solid #bfd0ea;
  border-bottom: none;
  background: #e6edf7;
  color: #45607f;
  padding: 8px 14px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 2px;
  line-height: 1.2;
}

.tab-btn.active {
  background: #f2f6fb;
  color: #2d405a;
  font-weight: 700;
}

.form-panel {
  border: 1px solid #bfd0ea;
  border-top: none;
  background: rgba(255,255,255,0.12);
  padding: 14px 12px 8px;
}

.field-row {
  display: grid;
  grid-template-columns: 170px 1fr 180px 1fr;
  align-items: center;
  gap: 10px 18px;
  margin-bottom: 10px;
}

.field-label {
  font-size: 12px;
  font-weight: 700;
  color: #2d405a;
}

.right-label {
  margin-left: 6px;
}

.field-control {
  width: 100%;
}

.field-control input,
.field-control select {
  width: 100%;
  height: 32px;
  border: 1px solid #bfd0ea;
  background: #efefef;
  border-radius: 3px;
  color: #2d405a;
  padding: 0 10px;
  box-sizing: border-box;
  font-size: 12px;
}

.small-select {
  max-width: 90px;
}

.radio-row {
  display: flex;
  align-items: center;
  gap: 18px;
}

.radio-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #2d405a;
}

.radio-inline input {
  width: 14px;
  height: 14px;
  margin: 3;
}

.additional-box {
  margin: 8px 0 16px 0;
  margin-left: auto;
  max-width: 330px;
  border: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.08);
  padding: 12px 14px;
}

.side-title {
  color: #2d405a;
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 10px;
}

.check-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #2d405a;
  margin-bottom: 8px;
}

.check-inline input {
  width: 14px;
  height: 14px;
  margin: 0;
}

.box-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 12px;
}

.btn {
  border: 1px solid #bfd0ea;
  background: #f5f7fb;
  color: #2d405a;
  border-radius: 3px;
  padding: 8px 14px;
  font-size: 12px;
  cursor: pointer;
}

.btn-primary {
  background: #dfeaf9;
  border-color: #aac0df;
}
.caddy-profile-page #form .box-tools .btn {
  border: 1px solid #b9c7dc;
  background: #f5f7fb;
  color: #2d405a;
  border-radius: 3px;
  padding: 7px 14px;
  font-size: 12px;
}

.caddy-profile-page #form .box-tools .btn-primary,
.caddy-profile-page #form .box-tools .btn-info {
  background: #dfeaf9;
  border-color: #aac0df;
}

.caddy-profile-page #form .box-tools .btn-warning {
  background: #fff2cc;
  border-color: #e5c76e;
  color: #7d5a00;
}

.caddy-profile-page #form .box-tools .btn-default {
  background: #f5f7fb;
}

@media (max-width: 980px) {
  .field-row {
    grid-template-columns: 1fr;
  }

  .right-label {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// GolfClub.vue?02238f76